import { render, staticRenderFns } from "./PastePopup.vue?vue&type=template&id=cc0d8152&scoped=true&"
import script from "./PastePopup.vue?vue&type=script&lang=js&"
export * from "./PastePopup.vue?vue&type=script&lang=js&"
import style0 from "./PastePopup.vue?vue&type=style&index=0&id=cc0d8152&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cc0d8152",
  null
  
)

export default component.exports